import GUI from './muigui.js';

import ColorChooser from './controllers/ColorChooser.js';
import Direction from './controllers/Direction.js';
import RadioGrid from './controllers/RadioGrid.js';
import Range from './controllers/Range.js';
import Select from './controllers/Select.js';
import Slider from './controllers/Slider.js';
import TextNumber from './controllers/TextNumber.js';
import Vec2 from './controllers/Vec2.js';

GUI.ColorChooser = ColorChooser;
GUI.Direction = Direction;
GUI.RadioGrid = RadioGrid;
GUI.Range = Range;
GUI.Select = Select;
GUI.Slider = Slider;
GUI.TextNumber = TextNumber;
GUI.Vec2 = Vec2;

export default GUI;